import React from "react";
import { EvidenciaImg } from "../../types/ot.types";
import { FileUploaderPreview } from "../FileUploaderPreview";

interface Step8Props {
    ordenId: string; // <-- AÑADIDO
    imagenesPago: EvidenciaImg[];
    setImagenesPago: React.Dispatch<React.SetStateAction<EvidenciaImg[]>>;
    estatusFirmaDigital: "pendiente" | "firmado" | "cancelado";
    isCompleted?: boolean;
    isImmediatePayment?: boolean;
    proveedor: {
        clave_periodo_pago: number;
    };
}

export const Step8FirmaPago: React.FC<Step8Props> = ({
    ordenId,
    imagenesPago,
    setImagenesPago,
    estatusFirmaDigital,
    isCompleted = false,
    isImmediatePayment = true,
    proveedor
}) => {

    // Función para abrir la Orden de Pago
    const handleImprimirOrden = () => {
        const url = `/sittApi/solicitudesServicio/generar_orden_pago_pdf.php?id=${ordenId}`;
        window.open(url, '_blank');
    };

    return (
        <div id="ot-step8-pago" className="row g-4 text-start">
            {/* <div className="col-12 mb-3">
                <div className="border rounded px-4 py-3 text-muted small shadow-sm bg-light">
                    <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
                        <div>
                            <i className="fas fa-file-invoice-dollar me-2 text-primary fs-5"></i>
                            La orden ha sido autorizada. Imprima la <strong>Orden de Pago</strong> para gestión interna y adjunte aquí el comprobante final de transferencia o pago emitido.
                        </div>
                        <button
                            type="button"
                            className="btn btn-outline-danger fw-bold shadow-sm"
                            onClick={handleImprimirOrden}
                        >
                            <i className="fas fa-file-pdf me-2"></i> Generar Orden de Pago (PDF)
                        </button>
                    </div>
                </div>
            </div> */}

            {proveedor?.clave_periodo_pago !== 1 && (
                <div className="col-12 mb-3">
                    <div className="alert alert-info">
                        <i className="fas fa-info-circle me-2"></i>
                        El taller asociado tiene crédito a 15/30 días. <strong>La carga de comprobantes en este paso no es obligatoria para continuar con la entrega.</strong>
                    </div>
                </div>
            )}

            <div className="col-md-6 border-end pe-md-4">
                <h6 className="fw-bold mb-3 small text-uppercase">
                    Estado de Control Presupuestal
                </h6>

                {estatusFirmaDigital === "firmado" ? (
                    <div className="alert alert-success d-flex align-items-center shadow-sm">
                        <i className="fas fa-check-circle fa-2x me-3"></i>
                        <div>
                            <h6 className="fw-bold mb-0">Pago Pre-Autorizado</h6>
                            <small>El pago ha pasado el control administrativo exitosamente.</small>
                        </div>
                    </div>
                ) : estatusFirmaDigital === "cancelado" ? (
                    <div className="alert alert-danger d-flex align-items-center shadow-sm">
                        <i className="fas fa-times-circle fa-2x me-3"></i>
                        <div>
                            <h6 className="fw-bold mb-0">Pago Rechazado/Cancelado</h6>
                            <small>Revise con administración de presupuesto.</small>
                        </div>
                    </div>
                ) : (
                    <div className="alert alert-warning d-flex align-items-center shadow-sm">
                        <i className="fas fa-hourglass-half fa-2x me-3"></i>
                        <div>
                            <h6 className="fw-bold mb-0">Firma Pendiente</h6>
                            <small>El pago aún no ha sido autorizado en el sistema matriz.</small>
                        </div>
                    </div>
                )}
            </div>

            <div className="col-md-6 ps-md-4">
                <h6 className="fw-bold mb-3 small text-uppercase">
                    Carga de Comprobante
                </h6>
                <FileUploaderPreview
                    label="Comprobante de Transferencia / SPEI"
                    archivos={imagenesPago}
                    setArchivos={setImagenesPago}
                    multiple={true}
                    accept="image/*,application/pdf"
                    disabled={isCompleted}
                />
            </div>
        </div>
    );
};